import * as React from 'react';
import { cn } from '@/shared/utils/cn';
import mastercardIcon from '@/shared/assets/images/cc-mastercard.svg';
import visaIcon from '@/shared/assets/images/cc-visa.svg';
import amexIcon from '@/shared/assets/images/amex-icon.png';

export interface WeAcceptProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'desktop' | 'mobile';
  label?: string;
  className?: string;
}

const WeAccept = React.forwardRef<HTMLDivElement, WeAcceptProps>(
  ({ variant = 'desktop', label = 'We Accept:', className, ...props }, ref) => {
    const isMobile = variant === 'mobile';
    const filterStyle = 'brightness(0) saturate(100%) invert(67%) sepia(10%) saturate(600%) hue-rotate(195deg) brightness(105%) contrast(88%)';

    const paymentMethods = [
      {
        name: 'Mastercard',
        icon: mastercardIcon,
        isSvg: true,
      },
      {
        name: 'Visa',
        icon: visaIcon,
        isSvg: true,
      },
      {
        name: 'American Express',
        icon: amexIcon,
        isSvg: false,
      },
    ];

    return (
      <div
        ref={ref}
        className={cn(
          'flex items-center gap-3',
          isMobile && 'justify-center mb-6',
          className
        )}
        {...props}
      >
        {!isMobile && <span className="text-xs text-white/80">{label}</span>}
        <div className={cn('flex', !isMobile && 'justify-start')}>
          {paymentMethods.map((method) => (
            <div
              key={method.name}
              className="w-12 h-8 rounded flex items-center overflow-hidden p-0.5"
            >
              <img
                src={method.icon}
                alt={method.name}
                className="w-full object-contain rounded-[4px]"
                style={method.isSvg ? { filter: filterStyle } : { height: '30px', width: 'fit-content' }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
);

WeAccept.displayName = 'WeAccept';

export { WeAccept };
